import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20Card', {
    staticClass: "dt-card-text-01 mb-4",
    attrs: {
      "offset": "30",
      "buttons": _vm.buttons
    },
    on: {
      "addItem": function ($event) {
        _vm.scopeDialog = true;
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.scopes')))]), _c(VCardTitle, {
    staticClass: "pa-0"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "single-line": "",
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.accessTableSearch,
      callback: function ($$v) {
        _vm.accessTableSearch = $$v;
      },
      expression: "accessTableSearch"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.scopeRoleEditingText')))])])], 1), _vm.scopeDialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.scopeDialog,
      "form": _vm.$refs['scopeSelectorForm'],
      "buttons": [{
        type: 'submit',
        icon: 'fa-save',
        title: _vm.$i18n_t('Common.save'),
        action: 'save'
      }],
      "max-width": "900"
    },
    on: {
      "close": _vm.scopeSelectorClosed,
      "save": _vm.scopeSelectorDialogSave
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('small', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.scopeSelectionHeaderText')))])];
      },
      proxy: true
    }], null, false, 3026717555)
  }, [_c(VForm, {
    ref: "scopeSelectorForm",
    model: {
      value: _vm.scopeSelectorFormValid,
      callback: function ($$v) {
        _vm.scopeSelectorFormValid = $$v;
      },
      expression: "scopeSelectorFormValid"
    }
  }, [_c('core-tenant-scope-access-selector', {
    ref: "scopeAccessSelector",
    attrs: {
      "userId": _vm.sessionUserId,
      "roles": _vm.scopeSelectorRoles,
      "isLoading": _vm.isLoadingScopeRoles
    },
    on: {
      "scopeChosen": _vm.scopeChosen,
      "scopeRolesChosen": _vm.rolesChosen
    }
  })], 1)], 1) : _vm._e()], 1), _vm.loading ? [_c(VSkeletonLoader, {
    attrs: {
      "type": "table-thead"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-2",
    attrs: {
      "type": "table-row-divider@2"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-auto",
    attrs: {
      "type": "table-tfoot"
    }
  })] : _c(VDataTable, {
    attrs: {
      "data-cy": "table_scopes_permissions",
      "headers": _vm.accessTableRolesHeaders,
      "items": _vm.selectedScopes,
      "search": _vm.accessTableSearch,
      "footer-props": _vm.accessTableFooterProps,
      "expanded": _vm.accessTableExpandedRows,
      "sort-by": ['id'],
      "sort-desc": [false],
      "item-key": "id"
    },
    on: {
      "update:expanded": function ($event) {
        _vm.accessTableExpandedRows = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          class: _vm.isPrimaryScope(props.item.id) ? 'highlighted' : null
        }, [_c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAccessTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.id))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAccessTableRow(props.item);
            }
          }
        }, [_c('span', {
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(_vm.fetchScopeDetails(props.item)))]), _c('p', {
          staticClass: "text-overline pt-1 mb-0 grey--text"
        }, [_vm._v(_vm._s((_vm.scopeDetails[props.item.id] || {}).crumbPath))]), _vm._v("\n          " + _vm._s((_vm.scopeDetails[props.item.id] || {}).name) + "\n        ")]), _c('td', {
          staticStyle: {
            "text-align": "right",
            "width": "120px"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteAccess(props.item.id);
            }
          }
        }, [_vm._v("fal fa-trash-alt")])], 1)])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', {
          class: _vm.isPrimaryScope(props.item.id) ? 'highlighted' : null
        }, [_c('td'), _c('td', [_c(VRow, [_c(VCol, {
          staticClass: "pt-6 pb-0"
        }, [_c('core-tenant-role-list', {
          attrs: {
            "data-cy": "tenant_role_list",
            "availableRoles": _vm.availableRoles,
            "loadRolesInternally": false,
            "isLoading": _vm.isLoadingScopeRoles,
            "scopeId": props.item.id,
            "tenantId": props.item.tenantId,
            "roles": _vm.filterRolesForScope(props.item.id, true)
          },
          on: {
            "rolesChosen": _vm.rolesChosen
          }
        })], 1)], 1)], 1), _c('td')])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.lines')) + " " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n      " + _vm._s(props.itemsLength) + "\n    ")];
      }
    }])
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };